import * as React from 'react';
import {
	StorageKeyBuilder,
	usePersistChangeInBrowserStorage,
} from '../../../../../models/hooks/usePersistChangeInBrowserStorage';

/**
 * Hook to manage selected agent template with localStorage persistence
 * Stores the last used agent template ID for Call Analysis
 */
export const useSelectedAgentTemplate = () => {
	// Build storage key with user scoping
	const storageKey = React.useMemo(
		() => StorageKeyBuilder.create('call-analysis-selected-agent-template').useUser().excludeFromClear().build(),
		[]
	);

	// Storage for selected template ID
	const [selectedTemplateId, setSelectedTemplateId] = usePersistChangeInBrowserStorage<string | null>({
		storageType: 'localStorage',
		storageKey,
		defaultIfEmpty: null,
	});

	return {
		selectedTemplateId,
		setSelectedTemplateId,
	};
};
